import { render, staticRenderFns } from "./CreateAccountEmail.vue?vue&type=template&id=298daa07&scoped=true&"
import script from "./CreateAccountEmail.vue?vue&type=script&lang=js&"
export * from "./CreateAccountEmail.vue?vue&type=script&lang=js&"
import style0 from "./CreateAccountEmail.vue?vue&type=style&index=0&id=298daa07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298daa07",
  null
  
)

export default component.exports